import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { storage } from '@/utils/storage';
import { projectName } from '@/utils/config';

export default [
  {
    path: '/IFPageOneHFiftyFivePreLogin',
    name: 'IFPageOneHFiftyFivePreLogin',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHFiftyFive/preLogin.vue'),
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 20230727 返回拦截下载页 */
      if (
        from.path === '/IFPageOneHFiftyFiveLogin' ||
        from.path === '/IFPageOneHFiftyFiveLoginSecond'
      ) {
        window.history.back();
      } else {
        next();
      }
    },
  },
  {
    path: '/IFPageOneHFiftyFiveLogin',
    name: 'pageOneHFiftyFiveLogin',
    meta: {
      title: '我的额度',
    },
    component: () => import('@/pages/pageListAll/pageOneHFiftyFive/login.vue'),
  },
  {
    path: '/IFPageOneHFiftyFiveLoginLoading',
    name: 'pageOneHFiftyFiveLoginLoading',
    meta: {
      title: '我的额度',
    },
    component: () => import('@/pages/pageListAll/pageOneHFiftyFive/loginLoading.vue'),
  },
  {
    path: '/IFPageOneHFiftyFiveLeaveInfo',
    name: 'pageOneHFiftyFiveLeaveInfo',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHFiftyFive/leaveInfo.vue'),
  },
  {
    path: '/IFPageOneHFiftyFiveResult',
    name: 'pageOneHFiftyFiveResult',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHFiftyFive/result.vue'),
  },
  {
    path: '/IFPageOneHFiftyFiveLoading',
    name: 'pageOneHFiftyFiveLoading',
    component: () => import('@/pages/pageListAll/pageOneHFiftyFive/loading.vue'),
    meta: {
      title: '额度检测',
    },
  },
  {
    path: '/IFPageOneHFiftyFiveLoginSecond',
    name: 'pageOneHFiftyFiveLoginSecond',
    component: () => import('@/pages/pageListAll/pageOneHFiftyFive/loginSecond.vue'),
    meta: {
      title: projectName,
    },
  },
  {
    path: '/IFPageOneHFiftyFiveOnline',
    name: 'pageOneHFiftyFiveOnline',
    component: () => import('@/pages/pageListAll/pageOneHFiftyFive/online.vue'),
    meta: {
      title: projectName,
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 网贷来源页 */
      if (from.path == '/IFPageOneHFiftyFiveLoginSecond') {
        storage.setItem('onlineGoApply', null);
      } else {
        to.query.time = `${new Date().getTime()}`;
      }
      next();
    },
  },
  {
    path: '/IFPageOneHFiftyFiveGuide',
    name: 'pageOneHFiftyFiveLoginGuide',
    component: () => import('@/pages/pageListAll/pageOneHFiftyFive/guide.vue'),
    meta: {
      title: projectName,
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      to.query.formUrl = from.path;
      next();
    },
  },
  /*{
    path: '/IFPageOneHFiftyFiveCar',
    name: 'pageOneHFiftyFiveCar',
    component: () => import('@/pages/pageListAll/pageOneHFiftyFive/car.vue'),
    meta: {
      title: '补充留资',
    },
  },
  {
    path: '/IFPageOneHFiftyFiveCarDetails',
    name: 'pageOneHFiftyFiveCarDetails',
    component: () => import('@/pages/pageListAll/pageOneHFiftyFive/carDetails.vue'),
    meta: {
      title: '申请结果',
    },
  },*/
  {
    path: '/IFPageOneHFiftyFiveBlank',
    name: 'pageOneHFiftyFiveBlank',
    component: () => import('@/pages/pageListAll/pageOneHFiftyFive/blank.vue'),
    meta: {
      title: projectName,
    },
  },
  {
    path: '/IFPageOneHFiftyFiveOnlineTab',
    name: 'pageOneHFiftyFiveOnlineTab',
    component: () => import('@/pages/pageListAll/pageOneHFiftyFive/onlineTab.vue'),
    meta: {
      title: projectName,
    },
  },
  {
    path: '/IFPageOneHFiftyFiveOnlineAd',
    name: 'pageOneHFiftyFiveOnlineAd',
    component: () => import('@/pages/pageListAll/pageOneHFiftyFive/onlineAd.vue'),
    meta: {
      title: projectName,
    },
  },
];
